import { Component, OnInit, HostListener, Input } from '@angular/core';
import { AppSettingService } from '../../app.service';

@Component({
	selector: 'app-google-map',
	templateUrl: './google-map.component.html',
	styleUrls: ['./google-map.scss'],
	standalone: false
})
export class GoogleMapComponent implements OnInit {
	@Input() mapOnly: boolean = false;
	@Input() title: string = "";
	@Input() subtitle: string = "";
	@Input() loc: any = "";

	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();
	width: number = 1280;
	lgView: boolean = true;

	@HostListener('window:resize', ['$event']) onResize(e: any) {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
		this.setView();
	}

	toggleCollapse(): void {
		if (this.toggled == false) {
			this.toggled = true;
		}
		else {
			this.toggled = false;
			setTimeout(() => {
				this.setView();
			}, 1000);
		}
	}

	private setView(): void {
		this.width = window.innerWidth;
		if (this.width > AppSettingService.mobileBreakPoint) {
			this.lgView = true;
		}
		else {
			this.lgView = false;
		}
		let divCollegeMap = document.getElementById("gMap");
		if (divCollegeMap == undefined) {
			return;
		}

		let uluru = { lat: parseFloat(this.loc.Latitude), lng: parseFloat(this.loc.Longitude) };
		let gMap = new google.maps.Map(
			divCollegeMap,
			{
				zoom: 11,
				center: uluru,
				fullscreenControl: false,
				mapId: AppSettingService.appConfig.GoogleMapId
			}
		);
		let gMarker = new google.maps.marker.AdvancedMarkerElement(
			{
				title: this.title,
				position: uluru,
				map: gMap
			}
		);
		google.maps.event.addListener(gMarker, "click", this.gotoSchool);

		// when redraw map, it will not show, so use resize to force map to be re-drawed.
		google.maps.event.addListenerOnce(gMap, 'idle', () => {
			google.maps.event.trigger(gMap, 'resize');
			gMap.setCenter(gMarker.position); // re-center the marker
		});
	}

	gotoSchool(): void {
		let url = "https://www.google.com/maps/dir/" + this.loc.Latitude + ',' + this.loc.Longitude + '/@' + this.loc.Latitude + ',' + this.loc.Longitude;
		window.open(url, "_blank");
	}

	ngAfterViewInit(): void {
		this.setView();
	}

	ngOnInit(): void {
		this.gotoSchool = this.gotoSchool.bind(this);
	}
}


